export const mediasoupClientConfig = {
  defaultRoomId: "123",
  simulcastEncodings: [
    { maxBitrate: 150_000, scaleResolutionDownBy: 4 },
    { maxBitrate: 500_000, scaleResolutionDownBy: 2 },
    { maxBitrate: 1_500_000, scaleResolutionDownBy: 1 },
  ],
  audioConstraints: {
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: false,
    channelCount: 1,
    sampleRate: 480000,
    sampleSize: 16,
  } satisfies MediaTrackConstraints,
  videoConstraints: {
    width: { ideal: 1280 },
    height: { ideal: 720 },
    frameRate: { ideal: 30, max: 30 },
  } satisfies MediaTrackConstraints,
};
